import React, { FC } from 'react';

import Option from '@/components/Option/Option';

import classes from './classes.module.css';

interface OptionsProps {
  selectedTables: number[];
  onSelectTable: (value: number) => void;
}

const Options: FC<OptionsProps> = ({ selectedTables, onSelectTable }) => {
  return (
    <div className={classes.container}>
      {new Array(10).fill(0).map((_, index) => (
        <Option
          key={index}
          value={index + 1}
          isSelected={selectedTables.includes(index + 1)}
          onClick={() => onSelectTable(index + 1)}
        />
      ))}
    </div>
  );
};

export default Options;
